import { useMemo } from 'react';
import { usePublicRealplayStore } from './publicRealPlays.store';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const PublicRealPlayHelper = () => {
  //values
  const { realPlayTranscription, token, tempTitle } = usePublicRealplayStore();

  const { realPlayRecording, isLoadingVideoTemp } = useRealplayStore();
  const globalRatingCriteria = realPlayRecording?.rating_criteria || [];

  const showResults = useMemo(
    () =>
      realPlayRecording?.status?.label === 'Qualified' ||
      realPlayRecording?.status?.label === 'Failed' ||
      realPlayRecording?.status?.label === 'Submitted',
    [realPlayRecording?.status?.label]
  );

  const status_assignment = realPlayRecording?.status || {};
  const isNotEmpty = useMemo(() => !!Object.keys(realPlayRecording)?.length, [realPlayRecording]);

  const assignment_uuid = realPlayRecording?.assignment_uuid || null;
  const assigned_by_user = realPlayRecording?.assigned_by_user || {};

  const roleplay = realPlayRecording?.roleplay || {};

  const scenarios = useMemo(
    () => realPlayRecording?.scenarios || [],
    [realPlayRecording?.scenarios]
  );
  const scenariosCompleted = useMemo(
    () => scenarios?.filter((item) => item?.response && item?.response?.video)?.length,
    [scenarios]
  );
  const scenarios_response = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sce) => ({
      scenario_uuid: sce?.uuid,
      response_uuid: sce?.response?.uuid,
    }));
  }, [scenarios]);
  const scenariosLength = useMemo(() => scenarios?.length || 0, [scenarios]);

  const AIprospect = realPlayRecording?.ai_persona || {};
  const { role, industry, situation } = realPlayRecording?.customer_context || {};
  const endDate = realPlayRecording?.end_date || null;
  const title = realPlayRecording?.roleplay?.name || '';
  const roleplay_description = realPlayRecording?.roleplay?.description || '';

  const selectedScenario = useMemo(
    () => realPlayRecording?.scenarioSelected,
    [realPlayRecording?.scenarioSelected]
  );
  const scenario_uuid = useMemo(() => selectedScenario?.uuid, [selectedScenario?.uuid]);
  const rating_criteria = useMemo(
    () => selectedScenario?.response?.rating_criterials,
    [selectedScenario?.response]
  );
  const feedback = useMemo(() => selectedScenario?.response?.comment, [selectedScenario?.response]);

  const summary = useMemo(
    () => selectedScenario?.response?.summary,
    [selectedScenario?.response?.summary]
  );

  const videoURL = useMemo(() => selectedScenario?.response?.video, [selectedScenario]);
  const tempVideoUrl = useMemo(
    () => selectedScenario?.tempVideoUrl,
    [selectedScenario?.tempVideoUrl]
  );

  const sessionInfoTemp = useMemo(
    () => realPlayRecording?.sessionInfoTemp,
    [realPlayRecording?.sessionInfoTemp]
  );
  const session_uuid = useMemo(() => sessionInfoTemp?.session_id, [sessionInfoTemp]);
  const status = useMemo(() => sessionInfoTemp?.status, [sessionInfoTemp]);

  //functions
  const { setRealPlayTranscription, setToken, setTempTitle, closeModal, reset } =
    usePublicRealplayStore();

  const {
    setRealPlayRecording,
    setScenarioWithSelector,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    reset: resetGlobalStore,
  } = useRealplayStore();

  return {
    realPlayRecording,
    transcription: realPlayTranscription,
    isLoadingVideoTemp,
    token,
    tempTitle,
    scenario_uuid,
    videoURL,
    tempVideoUrl,
    session_uuid,
    status,
    globalRatingCriteria,
    showResults,
    status_assignment,
    isNotEmpty,
    assignment_uuid,
    assigned_by_user,
    roleplay,
    scenarios,
    scenariosCompleted,
    scenarios_response,
    scenariosLength,
    AIprospect,
    role,
    industry,
    situation,
    endDate,
    title,
    roleplay_description,
    selectedScenario,
    rating_criteria,
    feedback,
    summary,
    setRealPlayTranscription,
    setToken,
    setTempTitle,
    closeModal,
    reset,
    setRealPlayRecording,
    setScenarioWithSelector,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    resetGlobalStore,
  };
};

export default PublicRealPlayHelper;
